import React from "react";
import Layout from "../components/shared/layout";
import Button from "../components/shared/button";
 
const NotFoundPage = () => {
    return (
        <Layout menuColor="[#fff]">
            <section className='bg-[linear-gradient(0deg,#f7fbfd_0%,#359dd0_100%)] md:py-[120px] py-[70px]'>
                <div className='container'>
                    <div className="text-center max-w-[580px] mx-auto">
                        <h1 className="md:text-[200px] text-[100px] md:leading-[200px] leading-[100px] md:pt-[80px] pt-[60px] text-white">4<span className="animate-bounce inline-block text-[#e63d25]">0</span>4</h1>
                        <h2 className="mb-[20px] font-extrabold"><span className="text-[#e63d25]">OooPs!</span> Page Not Found</h2>
                        <p className="md:text-[20px] mb-[30px]">It looks like nothing was found at this location. Maybe try one of the links below or a search?</p>

                        <Button hrefLink='/' title='Go to Home' />
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default NotFoundPage